import { BuildingType } from "components/BuildingProfile/types";

import type { BuildingTypeArray, MixConfiguration, MixUseKey } from "../model/types";

import { MIX_USE_KEYS } from "../model/mix";

export const convertBuildingTypeArrayToFormData = (
  buildingType: BuildingTypeArray | undefined
): {
  building_type: BuildingType | undefined;
  mixConfiguration: MixConfiguration | undefined;
} => {
  if (!buildingType?.length) return { building_type: undefined, mixConfiguration: undefined };

  const mixConfiguration = Object.fromEntries(
    buildingType
      .filter((type) => MIX_USE_KEYS.includes(type.type as MixUseKey))
      .map(({ percentage, type }) => [type.toLowerCase(), percentage])
  ) as MixConfiguration;
  const fullBuildingType = buildingType.find(({ percentage }) => percentage === 100);

  return {
    building_type: fullBuildingType ? (fullBuildingType.type.toLowerCase() as BuildingType) : "mixed",
    mixConfiguration,
  };
};
